module.exports = __webpack_public_path__ + "static/media/tent.3bca8424.svg";